/**
 * Shared click behaviour for Losi marks:
 * every click plays `jiggle`, and every click also counts toward the
 * five-tap Games ritual — they stack, neither replaces the other.
 */

import type { MouseEvent } from 'react'

import { originFromLosiElement } from '@/lib/losi-games/morph'
import type { LosiGamesOpenOrigin } from '@/lib/losi-games/types'

export const LOSI_JIGGLE_MS = 900

export function losiMarkTapOrigin(e: MouseEvent<HTMLElement>): LosiGamesOpenOrigin {
  return originFromLosiElement(e.currentTarget)
}
